var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chapter-preview"},[_c('ul',_vm._l((_vm.imageList),function(image){return _c('li',{key:image.imgUrl},[_c('img',{attrs:{"src":_vm.$config.cdn + _vm.$utils.filterImagePath(image.imgUrl)}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }